import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogContent, IconButton, TextField, Typography, InputLabel, MenuItem, Select, FormControl, Stack, } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const ReasonModal = ({ onClose, fetchData, propData }) => {
  const [form, setForm] = useState({ name: "" });
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("")

  useEffect(() => {
    if (propData) {
      setName(propData?.name || "");
    }
  }, [propData]);

  const submitHandler = async () => {
    if (!name.trim()) {
      window.NotificationUtils.showError("Please fill The Details");
      return;
    }
    setLoading(true);
    try {
      if (propData) {
        await window.Platform.database.updateReason({
          name: name,
          id: propData.id,
        });
        window.NotificationUtils.showSuccess("Update successfully");
      } else {
        let result = await window.Platform.database.addReason({ name });
        window.NotificationUtils.showSuccess(result?.message);
      }
      setName("");
      fetchData();
      onClose();
    } catch (err) {
      window.NotificationUtils.showError(err?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog disableEnforceFocus maxWidth="sm" fullWidth open>
      <StyledDialogContent>
        <ModalHeaderContainer>
          <Typography variant="h5">{propData ? "Edit" : "Add New"} Reason </Typography>
          <IconButton onClick={onClose}>
            <CloseOutlined />
          </IconButton>
        </ModalHeaderContainer>

        {loading && <OpaqueLoading />}

        <Stack gap={2} padding={2}>
          <FormControl fullWidth>

            <TextField
              label="Name"
              value={name || ''}
              type="text"
              // onChange={(e) => setName(e.target.value)}
              onChange={(e) => setName(e.target.value.replace(/^\s+/, ""))}
              fullWidth
            />

          </FormControl>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

            <Button
              color="primary"
              variant="contained"
              onClick={submitHandler}
              disabled={!name}
            >
              {propData ? 'Update' : 'Create'}
            </Button>
          </div>
        </Stack>
      </StyledDialogContent>

    </Dialog>
  );
};

export default ReasonModal;
